import * as React from 'react';

const ContentSVG = (props) => {
  return <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clip-path="url(#clip0_83_1111)">
      <path d="M13.5 5.0625H4.5V6.1875H13.5V5.0625Z" fill="#727684"/>
      <path d="M4.5 8.4375H13.5V9.5625H4.5V8.4375Z" fill="#727684"/>
      <path d="M11.8125 11.8125H4.5V12.9375H11.8125V11.8125Z" fill="#727684"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M1.6875 3.375C1.6875 2.44302 2.44302 1.6875 3.375 1.6875H14.625C15.557 1.6875 16.3125 2.44302 16.3125 3.375V14.625C16.3125 15.557 15.557 16.3125 14.625 16.3125H3.375C2.44302 16.3125 1.6875 15.557 1.6875 14.625V3.375ZM3.375 2.8125H14.625C14.9357 2.8125 15.1875 3.06434 15.1875 3.375V14.625C15.1875 14.9357 14.9357 15.1875 14.625 15.1875H3.375C3.06434 15.1875 2.8125 14.9357 2.8125 14.625V3.375C2.8125 3.06434 3.06434 2.8125 3.375 2.8125Z" fill="#727684"/>
    </g>
    <defs>
      <clipPath id="clip0_83_1111">
        <rect width="18" height="18" fill="white"/>
      </clipPath>
    </defs>
  </svg>
}

export default ContentSVG